<template>
  <div class="t-profile-child__container t-profile__box">
    <h2 class="t-profile-child__title">{{ $root.staticText.lk.notificationTitle }}</h2>
    <div class="t-profile-child__subtext">{{ $root.staticText.lk.notificationText }}</div>

    <form class="t-profile-child__form t-form" @submit.stop.prevent="submit()">
      <div class="t-form__item" :class="{ _lk2: form.length < 5, _lk3: form.length > 4 }" v-for="(item, index) in form">
        <div v-if="item.type === 'checkbox'" class="">
          <input
            :checked="item.checked"
            :id="item.name.toString() + index"
            :name="item.name"
            class="t-checkbox"
            :type="item.type"
            @change="item.checked = !item.checked"
          />
          <label :for="item.name.toString() + index" class="t-checkbox__text">{{ item.label }}</label>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.7064 5.29279C16.8939 5.48031 16.9992 5.73462 16.9992 5.99979C16.9992 6.26495 16.8939 6.51926 16.7064 6.70679L8.70643 14.7068C8.5189 14.8943 8.2646 14.9996 7.99943 14.9996C7.73427 14.9996 7.47996 14.8943 7.29243 14.7068L3.29243 10.7068C3.11027 10.5182 3.00948 10.2656 3.01176 10.0034C3.01403 9.74119 3.1192 9.49038 3.30461 9.30497C3.49002 9.11956 3.74083 9.01439 4.00303 9.01211C4.26523 9.00983 4.51783 9.11063 4.70643 9.29279L7.99943 12.5858L15.2924 5.29279C15.48 5.10532 15.7343 5 15.9994 5C16.2646 5 16.5189 5.10532 16.7064 5.29279Z"
              fill="#00b0bd"
            />
          </svg>
        </div>
      </div>

      <button class="t-btn _lk _green t-profile-child__btn t-form__btn _top" :class="{ _disabled: disabledBtn }">
        {{ $root.staticText.lk.securityBtn }}
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'notification',
  data() {
    return {
      form: [],
      disabledBtn: false,
    }
  },
  methods: {
    ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),

    submit() {
      let is_valid = true

      if (is_valid) {
        this.disabledBtn = true
        let fd = new FormData()

        for (let i = 0; i < this.form.length; i++) {
          fd.append('eventGroups[' + this.form[i].name + ']', Number(this.form[i].checked))
        }

        let action = process.env.NODE_ENV !== 'production' ? 'lk/logout.json' : 'lk/profilePage/notification'
        let methods = process.env.NODE_ENV !== 'production' ? 'get' : 'post'

        Vue.http[methods](action, fd)
          .then(response => response.json())
          .then(data => {
            this.disabledBtn = false

            if (data.success) {
              // перезаписываем новый массив уведомлений
              this.form.forEach(item => {
                this.$parent.notifications.forEach(subs => {
                  if (item.name === subs.id) {
                    subs.checked = item.checked
                  }
                })
              })

              this.modalType_lkSuccessOpen({
                title: this.$root.staticText.lk.successText,
                closeBthNone: true,
              })
            } else {
              this.openError(data)
            }
          })
          .catch(data => {
            this.disabledBtn = false
            this.openError(data)
          })
      }
    },
    openError(data) {
      let text = this.$root.staticText.lk.lkErrorText
      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }
      this.modalType_lkErrorOpen({
        title: this.$root.staticText.lk.lkErrorTitle,
        text: text,
        closeBthNone: true,
      })
    },
    focus(i) {
      this.form[i].error = false
    },
  },
  mounted() {
    setTimeout(() => {
      this.$parent.notifications.forEach(item => {
        this.form.push({
          label: item.label,
          name: item.id,
          type: 'checkbox',
          checked: item.checked,
        })
      })
    }, 100)
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/profile/notification/index.vue